import Layout from '@/modules/layout/components/layout';
import Permissions from '@/security/permissions';
import { storeAsync } from '../../app-module';

const TranslationsList = () => import('@/modules/translations/pages/TranslationsList.vue');
const GlossaryList = () => import('@/modules/translations/pages/GlossaryList.vue');
const TranslationsDashboard = () => import('@/modules/translations/pages/TranslationsDashboard.vue');

const getTranslationsModule = () => import('@/modules/translations/translations-store');
const importTranslationsStore = () =>
    getTranslationsModule().then((storeModule) => {
        if (!storeAsync().hasModule('translations')) storeAsync().registerModule('translations', storeModule.default);
        else return;
    });

export default [
    {
        path: '',
        component: Layout,
        meta: { auth: true },
        children: [
            {
                name: 'translationsGlossary',
                path: '/translations/glossary',
                component: GlossaryList,
                meta: {
                    auth: true,
                    permission: Permissions.values.glossaryRead,
                },
                beforeEnter: (to, from, next) => {
                    importTranslationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'translationsDashboard',
                path: '/translations/dashboard',
                component: TranslationsDashboard,
                meta: {
                    auth: true,
                    permission: Permissions.values.translationsRead,
                },
                beforeEnter: (to, from, next) => {
                    importTranslationsStore().then(() => {
                        next();
                    });
                },
            },
            {
                name: 'translations',
                path: '/translations',
                component: TranslationsList,
                meta: {
                    auth: true,
                    permission: Permissions.values.translationsRead,
                },
                beforeEnter: (to, from, next) => {
                    importTranslationsStore().then(() => {
                        next();
                    });
                },
            },
        ],
    },
];
